import { render, staticRenderFns } from "./LocalVideo.vue?vue&type=template&id=f0909ac6&scoped=true&"
import script from "./LocalVideo.vue?vue&type=script&lang=js&"
export * from "./LocalVideo.vue?vue&type=script&lang=js&"
import style0 from "./LocalVideo.vue?vue&type=style&index=0&id=f0909ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0909ac6",
  null
  
)

export default component.exports